import React, { useCallback, useEffect, useRef, useState } from "react";

import Table from "../../components/table/Table";

import { Controller, useForm } from "react-hook-form";

import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment";
import { debounce } from "lodash";

const NewsLetter = () => {
  const { doLogin, currUserData } = useAuthContext();

  const [data, setData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      getNewsletter(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const getNewsletter = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/subscribe/getAllSubscribers?page=${
        pageIndex + 1
      }&limit=${pageSize}&search=${term}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setData(res?.data);
      setIsLoading(false);
      setTotalCount(res?.pagination?.total);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Email ID",
        accessor: "email",
      },

      //   {
      //     Header: "Status",
      //     accessor: "status",
      //     Cell: ({ row }) => (
      //       <div class="form-check form-switch">
      //         <input
      //           onChange={() => handleToggleStatus(row.index)}
      //           className="form-check-input"
      //           type="checkbox"
      //           id="mySwitch"
      //           name="darkmode"
      //           value="yes"
      //           checked={row.original.status === 1 ? true : false}
      //         />
      //       </div>
      //     ),
      //   },
      {
        Header: "Created On",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.createdAt, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },

      // {
      //   Header: "Action",
      //   accessor: "",
      //   Cell: ({ row }) => (
      //     <div class="dropdown">
      //       <span
      //         data-bs-toggle="dropdown"
      //         style={{ cursor: "pointer" }}
      //         aria-expanded="false"
      //       >
      //         <i class="fas fa-ellipsis-v"></i>
      //       </span>
      //       <ul class="dropdown-menu">
      //         <li>
      //           <span
      //             className="me-3 cursor-pointer"
      //             style={{ cursor: "pointer" }}
      //             // onClick={() => {
      //             //   handleEdit(row.original);
      //             // }}
      //           >
      //             View
      //           </span>
      //         </li>
      //       </ul>
      //     </div>
      //   ),
      // },
    ],
    []
  );

  useEffect(() => {
    getNewsletter();
  }, [pageIndex, pageSize]);

  return (
    <>
      <div className="ticket_management">
        <div className="p-40">
          <div className="page_heading mb-4">
            <div>
              <p className="heading">NewsLetter</p>
            </div>
            {/* <button
              className="btn_primary"
              onClick={() => setPopupShow(!popupShow)}
            >
              
            </button> */}
          </div>

          <div className="ticket_list ">
            <Table
              columns={columns}
              data={data}
              onSearch={handelSearch}
              isLoading={isLoading}
              totalCount={totalCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              setPageIndex={setPageIndex}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewsLetter;
